export default __webpack_public_path__ + "static/media/star.159b8141.png";